import api from "../../../api";
import { getBackendUrl } from "../../../util/envFn";
import { Job } from "../types";

export const fetchJobs = async (search: string, location: string, sortBy: string, sortOrder: string): Promise<Job[]> => {
    const res = await api.get(getBackendUrl('/jobs'), { params: { search, location, sortBy, sortOrder } });
    return res.data.map((job: Job) => ({
        id: job._id,
        ...job,
    }));
}; 